<template>
  <div>
    <van-popup
      v-if="isNewPrivacy"
      position="bottom"
      v-model="visible"
      @close="handleClose"
      :close-on-click-overlay="false"
      class="wrap--new"
      closeable
    >
      <header class="header">
        <h2 class="header--title">服务协议及隐私保护</h2>
      </header>
      <main class="main">
        <p>
          为了更好地保障您的合法权益，请您阅读并同意<span
            style="color: #63a6ff"
            @click="seeUserAgreement"
          >
            《用户协议》
          </span>
          和
          <span style="color: #63a6ff" @click="seePrivacyAgreement">
            《隐私协议》
          </span>
        </p>
      </main>
      <footer class="footer">
        <button class="btn" @click.stop="handleClose">不同意</button>
        <button class="btn btn__green" @click.stop="handleConfirm">
          同意并继续
        </button>
      </footer>
    </van-popup>
    <van-popup
      v-else
      v-model="visible"
      @close="handleClose"
      :close-on-click-overlay="false"
      class="wrap--old"
    >
      <header class="header">
        <h2 class="header--title">请阅读并同意以下条款</h2>
      </header>

      <div class="main">
        <div class="content">
          <p class="item item--title">欢迎您使用森果云果蔬零售管理软件！</p>
          <p class="item">
            为了提供基本服务和保障用户体验，我们会收集
            <br />
            必要的个人身份信息和设备信息。
          </p>
          <p class="item">
            完整阅读并同意
            <span style="color: #63a6ff" @click="seeUserAgreement">
              《用户协议》
            </span>
            和
            <span style="color: #63a6ff" @click="seePrivacyAgreement">
              《隐私协议》 </span
            >后，
            <br />
            可继续使用本软件。
          </p>
        </div>
      </div>

      <footer class="footer">
        <button class="btn" v-if="!hasLogin" @click.stop="handleExit">
          不同意并退出
        </button>
        <button class="btn" v-else @click.stop="handleClose">不同意</button>
        <button class="btn btn__green" @click.stop="handleConfirm">
          同意并继续
        </button>
      </footer>
    </van-popup>
  </div>
</template>

<script>
import { privacyUrl, userUrl } from "@/config/config";
import { checkIsNewPrivacy } from "@/utils/index";
import JsBridge from "@/assets/js/js-bridge";

export default {
  props: {
    hasLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      isNewPrivacy: checkIsNewPrivacy(),
    };
  },

  methods: {
    // public method
    show() {
      this.visible = true;
    },
    handleExit() {
      this.handleClose();
      JsBridge.invokeMethod("exit");
    },
    handleClose() {
      this.visible = false;
      this.$emit("close");
    },
    handleConfirm() {
      this.handleClose();
      this.$emit("confirm", true);
    },
    seeUserAgreement() {
      window.location.href = userUrl;
    },

    seePrivacyAgreement() {
      window.location.href = privacyUrl;
    },
  },
};
</script>

<style scoped lang="scss">
.wrap--old {
  width: calc(100% - 20px);
  border-radius: 20px;
  .header {
    display: flex;
    align-items: center;
    height: 50px;
    margin-left: 10px;
  }
  .header--title {
    font-weight: bold;
    font-size: 16px;
  }
  .main {
    margin: 0 10px;
    line-height: 1.5;
  }
  .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
    color: #333;
  }
  .item {
  }
  .item--title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .footer {
    position: relative;

    display: flex;
    align-items: center;
    margin: 10px 10px 0;
    border-top: 1px solid #ebebeb;

    &::after {
      position: absolute;
      content: "";
      left: 50%;
      top: 0;
      bottom: 0;
      width: 1px;
      background: #ebebeb;
    }
  }
  .btn {
    flex: 0 0 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-size: 16px;
    font-weight: bold;
    background: transparent;
    border: none;
    outline: none;
  }

  .btn__green {
    color: #009688;
  }
}
.wrap--new {
  height: 250px;
  /deep/ &.van-popup {
    border-radius: 20px 20px 0 0;
  }

  .header {
    display: flex;
    align-items: center;
    height: 50px;
    margin-left: 10px;
  }
  .header--title {
    font-weight: bold;
    font-size: 16px;
  }

  .main {
    padding: 0 10px;
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
  }

  .footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px 20px;
  }
  .btn {
    flex: 0 0 50%;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    overflow: hidden;
    outline: none;
    box-sizing: border-box;
    background: #fff;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #ddd;
    border-radius: 12px;
    user-select: none;

    &:active {
      opacity: 0.8;
    }
  }

  .btn__green {
    margin-left: 10px;
    color: #fff;
    background: linear-gradient(180deg, #14cc9b 0%, #009688 86%);
    border-color: #009688;
    border-width: 0;
    box-shadow: 0px 10px 20px -10px rgba(0, 150, 136, 0.5);
    &:active {
      background: #009688;
    }
  }
}
</style>
